import Button from '@atlaskit/button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle
} from '@atlaskit/modal-dialog';

interface ShareModalProps {
  onClose: (accept: boolean) => void;
}

export const ShareModal = ({ onClose }: ShareModalProps) => {
  return (
    <Modal onClose={() => onClose(false)} width="small">
      <ModalHeader>
        <ModalTitle>{'Share your changes'}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p>
          {
            'Anyone with this link can view exactly what you’re seeing — no setup needed.'
          }
        </p>
      </ModalBody>
      <ModalFooter>
        <Button appearance="subtle" onClick={() => onClose(false)}>
          {'Keep editing'}
        </Button>
        <Button appearance="primary" onClick={() => onClose(true)} autoFocus>
          {'Copy Link'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
